import { configureStore } from '@reduxjs/toolkit';
import { createSocketMiddleware } from '../utils/socket';
import rootReducer from './reducers';
import baseApi from '../api/baseApi';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(
      createSocketMiddleware(),
      baseApi.middleware
    )
});

export default store;
